import FontFormView from "./FontFormView";

function FontForm({
  setPrinterData,
  selectedLabelItem,
  selectedLabelItemIndex,
  submitError,
}) {
  /**
   * This method will handle the font size change event.
   * @param {event} e
   */
  function onFontSizeChange(e) {
    setPrinterData((prev) => ({
      ...prev,
      label_items: prev.label_items.map((item, index) =>
        index === selectedLabelItemIndex
          ? {
              ...item,
              font_size: e.target.value,
            }
          : item
      ),
    }));
  }

  /**
   * This method will handle the font weight change event.
   * @param {string} value
   */
  function onFontWeightChange(value) {
    setPrinterData((prev) => ({
      ...prev,
      label_items: prev.label_items.map((item, index) =>
        index === selectedLabelItemIndex
          ? {
              ...item,
              font_weight: value,
            }
          : item
      ),
    }));
  }

  /**
   * This method will handle the text alignment change event.
   * @param {string} value
   */
  function onTextAlignChange(value) {
    setPrinterData((prev) => ({
      ...prev,
      label_items: prev.label_items.map((item, index) =>
        index === selectedLabelItemIndex
          ? {
              ...item,
              text_align: value,
            }
          : item
      ),
    }));
  }

  return (
    <FontFormView
      selectedLabelItem={selectedLabelItem}
      selectedLabelItemIndex={selectedLabelItemIndex}
      onFontSizeChange={onFontSizeChange}
      onFontWeightChange={onFontWeightChange}
      onTextAlignChange={onTextAlignChange}
      submitError={submitError}
    />
  );
}

export default FontForm;
